<div class="row border-bottom pb-2 arabic-dir">
  <h5 class="text-primary text-left col-9">
    {{ "BAZZAR.FORGETTEN_PASSWORD" | translate }}
  </h5>
  <i
    class="fa fa-times text-dark text-right text-left-ar col-3 pt-1"
    (click)="onNoClick()"
  >
  </i>
</div>
<div class="mt-2 text-left">
  <small class="text-left">
    {{ "BAZZAR.SEND_EMAIL_TO_REST_PASSWORD" | translate }}
  </small>

  <form action="" class="mt-4 px-2" [formGroup]="forgetPasswordForm">
    <div class="form-group px-0">
      <label class="text-left small text-dark font-weight-600">
        {{ "BAZZAR.EMAIL" | translate }}
      </label>
      <input
        class="form-control"
        formControlName="email"
        type="email"
        maxlength="150"
      />
      <mat-error
        *ngIf="
          forgetPasswordForm.controls.email.errors?.required &&
          forgetPasswordForm.controls.email.touched
        "
      >
        {{ "BAZZAR.REQUIRED" | translate }}
      </mat-error>
      <mat-error
        *ngIf="forgetPasswordForm.controls.email.hasError('invalidEmail')"
      >
        {{ "BAZZAR.EMAIL_PATTERN" | translate }}
      </mat-error>
    </div>
  </form>

  <div class="mt-4">
    <button class="btn btn-success w-100">
      {{ "BAZZAR.RESET_YOUR_PASSWORD" | translate }}
    </button>
  </div>
</div>
